import Vue from 'vue'
import VueI18n from 'vue-i18n'
import fr from '../locales/fr.json'
import elementUIFr from 'element-ui/lib/locale/lang/fr'

Vue.use(VueI18n)

const messages = {
  FR: {
    ...fr,
    ...elementUIFr
  }
}

const i18n = new VueI18n({
  locale: localStorage.lang || 'FR',
  messages
})

export default i18n
